import { VIDEO_TEMPLATES_INFO } from "@talentbait/remotion-templates-talentbait";
import { IMAGE_MULTI_TEMPLATES } from "../../media-assets-lab/preview-area/PreviewArea";
import moment from "moment";
import { forceHttps } from "../../../../../utils/Helpers";

export function getVideoDuration(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const secureUrl = forceHttps(url);
    video.src = secureUrl;

    video.addEventListener("loadedmetadata", () => {
      resolve(video.duration);
      video.remove();
    });

    video.addEventListener("error", (event) => {
      reject("Error loading video: " + event.message);
      video.remove();
    });

    video.load();
  });
}

export const getVideoSize = (templateId, defaultWidth, defaultHeight) => {
  if (!templateId || templateId === "RawVideo") {
    return {
      videoHeight: Math.round(defaultHeight),
      videoWidth: Math.round(defaultWidth)
    };
  }
  return {
    videoHeight: VIDEO_TEMPLATES_INFO[templateId]?.height,
    videoWidth: VIDEO_TEMPLATES_INFO[templateId]?.width
  };
};

export const checkIfLandscape = (template, orientationChoice) => {
  const isLandscapeVersion = template?.type === "image" && template?.orientation === "landscape";

  const isRawVideoTemplateLandScape =
    template?.id === "RawVideo" && orientationChoice === "landscape";

  const isNewTemplatesLandScape =
    Object.keys(IMAGE_MULTI_TEMPLATES).includes(template?.id) && orientationChoice === "landscape";

  const isVideoTemplateLandscape =
    template?.type === "video" &&
    template?.orientation === "landscape" &&
    template?.id !== "RawVideo";

  return (
    isVideoTemplateLandscape ||
    isLandscapeVersion ||
    isRawVideoTemplateLandScape ||
    isNewTemplatesLandScape
  );
};

// Created for the changing of prop names in remotion templates
// Can be removed when campaigns are no longer using old props
export function mapInputPropsValues(inputProps) {
  const updatedProps = { ...inputProps };

  for (const key in inputProps) {
    const value = inputProps[key];

    if (["backgroundColor", "waveColor", "mainColor"].includes(key) && value) {
      updatedProps.primaryBackgroundColor = value;
    }

    if (["textColor", "titleColor"].includes(key) && value) {
      updatedProps.primaryTextColor = value;
    }

    if (key === "blobColor" && value) {
      updatedProps.secondaryBackgroundColor = value;
    }

    if (key === "header" && value) {
      updatedProps.secondaryText = value;
    }

    if (key === "title" && value) {
      updatedProps.text = value;
    }
  }

  return updatedProps;
}

const resetPropsMap = {
  primaryBackgroundColor: ["backgroundColor", "waveColor", "mainColor"],
  primaryTextColor: ["textColor", "titleColor"],
  secondaryBackgroundColor: ["blobColor"],
  secondaryText: ["header"],
  text: ["title"]
};

// Keys are new fields from brandkit, values are old values
export function resetOldInputProps(inputProps, key, value) {
  const updatedProps = { ...inputProps, [key]: value };

  if (resetPropsMap[key]) {
    resetPropsMap[key].forEach((prop) => {
      if (Object.prototype.hasOwnProperty.call(inputProps, prop)) {
        updatedProps[prop] = null;
      }
    });
  }
  return updatedProps;
}

/** TODO: Dec 2024
 * remove the following const when simple templates are not used in campaigns any more
 */
const SIMPLE_TEMPLATES_FUSION_DATE = moment("2024-12-17", "YYYY-MM-DD");
const TARGET_STATUSES = ["DRAFT", "WAITING_FOR_APPROVAL"];

export const isCampaignUsingSimpleTemplates = (status, createdDate) => {
  return (
    TARGET_STATUSES.includes(status) && moment(createdDate).isBefore(SIMPLE_TEMPLATES_FUSION_DATE)
  );
};

/**
 * TODO: Jan 2025
 * Checking is the default campaign older than 07/01/2025
 * If so, we can allow the new styling used in remotion templates.
 * Users can also use secondary text.
 * This can be removed when old campaigns are no longer used.
 */
const DEFAULT_TEMPLATE_STYLE_DATE = moment("2025-01-07", "YYYY-MM-DD");

export const isOldDefaultTemplateStyle = (status, createdDate) => {
  return (
    TARGET_STATUSES.includes(status) && moment(createdDate).isBefore(DEFAULT_TEMPLATE_STYLE_DATE)
  );
};
